import React, { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import {
  toggleLiveMatchList,
  toggleLiveMatchLiverModal,
  toggleLiveMatchRequest,
  updateUserRequestMatch,
} from '../../liveMatchSlice';
import { Button, Form, Modal } from 'react-bootstrap';
import arrowDownIcon from '../../../../assets/svg/arrow_gray_down.svg';
import editBlackIcon from '../../../../assets/svg/edit_black.svg';
import './LiveMatchRequestModal.scss';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import { usePostLiveMatchMutation } from '../../../../services/api/apiProvider';
import { RequestLiveMatch } from '../../../../services/api/models/request/requestLiveMatch';
import LiveMatchLiverModal from '../LiveMatchLiverModal/LiveMatchLiverModal';
import { toast } from 'react-toastify';
import { ErrorResponse } from '../../../../common/constants/globalConstants';
import { LiveMatchKindType } from '../../types/LiveMatchTypes';

const LiveMatchRequestModal = (): ReactElement => {
  const dispatch = useDispatch();
  const liveMatchState = useSelector((state: AppState) => state.liveMatch);
  const [postLiveMatch] = usePostLiveMatchMutation();
  const [typeMatch, setTypeMatch] = useState<string>(LiveMatchKindType.VS);
  const [message, setMessage] = useState<string>('よろしくお願いします！');

  const handleCloseModal = () => {
    dispatch(toggleLiveMatchRequest(false));
    dispatch(toggleLiveMatchList(true));
    dispatch(updateUserRequestMatch(undefined));
  };

  const handleSelectedMatch = (event: any) => {
    setTypeMatch(event.target.value);
  };
  const handleShowListLiver = () => {
    dispatch(toggleLiveMatchLiverModal(true));
  };
  const handleChangeMessage = (event: any) => {
    setMessage(event.target.value);
  };
  const handleSendRequest = () => {
    const request: RequestLiveMatch = {
      kind: typeMatch,
      liveId: liveMatchState.userRequestMatch?.liveId,
      message: message,
    };
    postLiveMatch(request)
      .unwrap()
      .then(() => {
        dispatch(toggleLiveMatchRequest(false));
        dispatch(toggleLiveMatchList(false));
        dispatch(updateUserRequestMatch(undefined));
        setTypeMatch(LiveMatchKindType.VS);
        setMessage('よろしくお願いします！');
      })
      .catch((error: ErrorResponse) => {
        toast.error(error.data.message);
      });
  };

  return (
    <>
      <Modal
        show={liveMatchState.isShowLiveMatchRequest}
        backdrop="static"
        keyboard={false}
        scrollable={true}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>指名する</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="root-live-match-request">
            <Form onChange={handleSelectedMatch}>
              <Form.Check
                style={{ fontWeight: '700' }}
                label="VS"
                name="live-match"
                type="radio"
                id={`inline-radio-1`}
                value={LiveMatchKindType.VS}
                defaultChecked
              />
              <p className="form-text-request">
                マッチングした相手と制限時間内にダイヤの獲得数を競い合う機能です。
              </p>
              <Form.Check
                style={{ fontWeight: '700' }}
                label="コラボ"
                name="live-match"
                type="radio"
                id={`inline-radio-2`}
                value={LiveMatchKindType.COLABO}
              />
              <p className="form-text-request">
                マッチングした相手とトークができる機能です。
              </p>
            </Form>
            <div className="live-match-request-user">
              <div className="live-match-request-user-title">
                <div
                  onClick={handleShowListLiver}
                  className="live-match-request-title"
                >
                  指名する
                </div>
                <div className="live-match-request-icon">
                  <img src={arrowDownIcon} alt="" />
                </div>
              </div>
              <div className="live-match-request-user-avatar">
                <ImageCustom
                  src={liveMatchState.userRequestMatch?.userPictureUri}
                />
              </div>
            </div>
            <div className="live-match-request-message">
              <div className="live-match-request-title">指名メッセージ</div>
              <div className="live-match-request-message-input">
                <Form.Control
                  onChange={handleChangeMessage}
                  placeholder="よろしくお願いします！"
                />
                <div className="live-match-request-message-icon">
                  <img src={editBlackIcon} alt="" />
                </div>
              </div>

              <div className="d-flex">
                <Form.Text>※20文字以内。絵文字も使用できます。</Form.Text>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button className="live-match-btn-cancel" onClick={handleCloseModal}>
            キャンセル
          </Button>
          <Button onClick={handleSendRequest} className="live-match-btn-accept">
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {liveMatchState.isShowLiveMatchLiver && <LiveMatchLiverModal />}
    </>
  );
};

export default LiveMatchRequestModal;
